function initAthaSlider() {

  document.querySelectorAll(".atha-related-slider").forEach(function (slider) {

    if (slider.dataset.initialized === "true") return;
    slider.dataset.initialized = "true";

    const track = slider.querySelector(".atha-related-track");
    const next = slider.querySelector(".atha-slider-arrow.next");
    const prev = slider.querySelector(".atha-slider-arrow.prev");

    if (!track || !next || !prev) return;

    next.addEventListener("click", function () {

      const card = track.querySelector(".atha-slide");
      if (!card) return;

      track.scrollBy({
        left: card.offsetWidth + 20,
        behavior: "smooth"
      });

    });

    prev.addEventListener("click", function () {

      const card = track.querySelector(".atha-slide");
      if (!card) return;

      track.scrollBy({
        left: -(card.offsetWidth + 20),
        behavior: "smooth"
      });

    });

  });

}

document.addEventListener("DOMContentLoaded", initAthaSlider);

new MutationObserver(initAthaSlider).observe(document.body, {
  childList: true,
  subtree: true
});



/* ---------- SIZE PICKER ---------- */

document.addEventListener("click", function (e) {

  const btn = e.target.closest(".atha-size-btn");
  if (!btn) return;

  if (btn.disabled) return;
  const card = btn.closest(".atha-card");

  card.querySelectorAll(".atha-size-btn").forEach(function (b) {
    b.classList.remove("active");
  });

  btn.classList.add("active");

});



/* ---------- ADD TO CART ---------- */

document.addEventListener("click", async function (e) {

  const btn = e.target.closest(".atha-add-cart-btn");
  if (!btn) return;
console.count("ATHA ADD TO CART");
  e.preventDefault();

  const card = btn.closest(".atha-card");

  const activeVariant = card.querySelector(".atha-size-btn.active");

  const variantId = activeVariant
    ? activeVariant.dataset.id
    : btn.dataset.variant;

  if (!variantId) {
    alert("Please select a size.");
    return;
  }

  btn.disabled = true;
  btn.textContent = "Adding...";

  try {

    const formData = new FormData();

    formData.append("id", variantId);
    formData.append("quantity", "1");

    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer) {

      formData.append(
        "sections",
        cartDrawer.getSectionsToRender().map(section => section.id)
      );

      formData.append(
        "sections_url",
        window.location.pathname
      );

    }

    const response = await fetch(
  "/cart/add.js",
      {
        method: "POST",
       headers: {
  "Accept": "application/json",
  "X-Requested-With": "XMLHttpRequest"
},
        body: formData
      }
    );

    const result = await response.json();


    console.log(result);
console.log(result.sections);


    if (result.status) {
      throw new Error(result.description || "Unable to add item.");
    }

    if (cartDrawer) {

    cartDrawer.classList.remove("is-empty");

    cartDrawer.renderContents(result);

}

    btn.textContent = "Added ✓";

    setTimeout(function () {

      btn.disabled = false;
      btn.textContent = "Add to Cart";

    }, 800);

  } catch (err) {

    console.error(err);

    btn.disabled = false;
    btn.textContent = "Add to Cart";

    alert(err.message);

  }

});